export const useWebGL = () => {
    const state = {
        isWebGLDetected: false, // This is a boolean value that will be set to true if we already detected WebGL support.
        isWebGLSupported: false, // This is a boolean value that will be set to true if the browser supports WebGL.
    };

    function checkWebGLSupport() {
        if (state.isWebGLDetected) {
            return state.isWebGLSupported;
        } else {
            try {
                const canvas = document.createElement("canvas");
                const gl =
                    canvas.getContext("webgl") ||
                    canvas.getContext("experimental-webgl");
                state.isWebGLSupported = !!(
                    gl && gl instanceof WebGLRenderingContext
                );
            } catch (e) {
                state.isWebGLSupported = false;
                console.error("WebGL not supported:", e);
            }
            state.isWebGLDetected = true;
            return state.isWebGLSupported;
        }
    }

    return {
        checkWebGLSupport,
    };
};
